var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isEmpty)?_c('div',{ref:"graph",staticClass:"p-competing-graph"},[_c('div',{staticClass:"p-competing-graph__bar",style:({ width: _vm.barWidth + '%' })},[_c('p',{ref:"text",staticClass:"p-competing-graph__text",style:(_vm.textStyle)},[_vm._v("\n      "+_vm._s(_vm._f("separateNumber")(_vm.value))+"\n    ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }